/*
  Productkaarten: verwachte leverperiode uit de Essential Pre-order app achter "Pre-order" zetten.
  De app zet zijn campagnes (met melding, bijv. "LEVERBAAR EIND NOVEMBER") op elke pagina in
  <essential-preorder-app-embed preorder-app-data="...">. De kaart geeft zijn selling plan mee via data-preorder-plan.
  Resultaat: "Pre-order, eind november". Zonder bekende periode blijft "Pre-order" staan.
*/
(() => {
  const MONTHS = 'januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december';
  const PERIOD_PATTERN = new RegExp(`(begin|medio|midden|eind)\\s+(${MONTHS})`, 'i');
  let periodsByPlan = null;

  const loadPeriods = () => {
    if (periodsByPlan) return periodsByPlan;
    const embed = document.querySelector('essential-preorder-app-embed[preorder-app-data]');
    if (!embed) return null;

    try {
      const data = JSON.parse(embed.getAttribute('preorder-app-data'));
      periodsByPlan = {};
      (data.preorderCampaigns || []).forEach((campaign) => {
        const match = (campaign.content?.message || '').match(PERIOD_PATTERN);
        if (!match) return;
        const period = `${match[1]} ${match[2]}`.toLowerCase();
        (campaign.sellingPlanIds || []).forEach((id) => (periodsByPlan[String(id)] = period));
      });
    } catch (error) {
      periodsByPlan = {};
    }
    return periodsByPlan;
  };

  const fill = () => {
    const targets = document.querySelectorAll('[data-preorder-plan]:not([data-preorder-filled])');
    if (!targets.length) return;
    const periods = loadPeriods();
    if (!periods) return;

    targets.forEach((el) => {
      el.setAttribute('data-preorder-filled', '');
      const period = periods[el.dataset.preorderPlan];
      if (period) el.textContent = `${el.textContent.trim()}, ${period}`;
    });
  };

  const start = () => {
    fill();
    // Kaarten die later binnenkomen (filters, aanbevelingen, recent bekeken) en de app-embed zelf
    new MutationObserver(fill).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
